import { render, staticRenderFns } from "./RelatorioPerformanceRegiaoFiltroModalItemInputRegiao.vue?vue&type=template&id=a05516d2"
import script from "./RelatorioPerformanceRegiaoFiltroModalItemInputRegiao.vue?vue&type=script&lang=js"
export * from "./RelatorioPerformanceRegiaoFiltroModalItemInputRegiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports